import { render, staticRenderFns } from "./AppointmentEntry.vue?vue&type=template&id=8b2b00d8&scoped=true&"
import script from "./AppointmentEntry.vue?vue&type=script&lang=js&"
export * from "./AppointmentEntry.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentEntry.vue?vue&type=style&index=0&id=8b2b00d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2b00d8",
  null
  
)

export default component.exports